export default __webpack_public_path__ + "static/media/PersonIcon.cf90ac43.svg";